import { createStore } from 'framework7';
import { http } from '../api/config.js';

const restrictedDate = createStore({
  state: {
    item: {},
    list: [],
  },
  actions: {
//Mutations
    set_item({ state }, item) {
      state.item = item;
    },
//End mutations

    async getListByCar({ dispatch }, carId){
      let response = [];
      let result = {};

      result = await http.get(`restricted/dates/list/${carId}`);
      if (result.status === 200){
        response = result.data;
        return response;
      }
      else{
        return result;
      }
    },

    async saveData({ dispatch }, { carId, itemsToSave }){
      let response = [];
      let result = {};

      result = await http.put(`restricted/dates/save/${carId}`, itemsToSave);
      if (result.status === 200){
        response = result.data;
        return response;
      }
      else{
        return result;
      }
    },

    async deleteInCar({ dispatch }, carId){
      let response = [];
      let result = {};

      result = await http.delete(`restricted/dates/delete/${carId}`);
      if (result.status === 200){
        response = result.data;
        return response;
      }
      else{
        return result;
      }
    },
  },
  getters: {
    Item({ state }) {
      return state.item;
    }
  },
});

export default restrictedDate;
